import { parse } from 'uuid';

angular.module('GlobalHelpersModule').factory 'UtilityService', ($log) ->
  compareGuids: (guid1, guid2) ->
    try
      bytes1 = parse(String(guid1))
      bytes2 = parse(String(guid2))
      # difference returns [] for equal arrays
      difference = _.difference(bytes1, bytes2)
      return difference.length == 0
    catch
      return false

  isRetiredWithoutFmh: ({ isRetired, isFmhOnboarded } = {}) ->
    isRetired is true and isFmhOnboarded isnt true

  # Which pending-invite retired wording to show. Anything we do not recognise as
  # an authorized individual falls back to the patient wording.
  retiredInviteVariant: (relationshipToPatient) ->
    relationship = String(relationshipToPatient ? '').trim().toLowerCase()
    if relationship in ['', 'self', 'patient', 'unknown']
      'patientInvite'
    else
      'authorizedIndividualInvite'

  truncate: (string, maxCharacters) ->
    substring = string.substring(0, maxCharacters)
    if string.length > maxCharacters
      return substring + "..."
    else
      return substring